import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

const windowSize = {
  width: window.innerWidth,
  height: window.innerHeight,
}

const isMobile = (a) => {
  if (a.width < 992) {
    return true
  } else {
    return false
  }
}

const isLandscape = (a) => {
  if (a.width > a.height) {
    return true
  } else {
    return false
  }
}

const initialState = {
  size: {
    width: windowSize.width,
    height: windowSize.height,
    mobile: isMobile(windowSize),
    landscape: isLandscape(windowSize),
  },
  activePopup: null,
  menuOpened: localStorage.getItem("menu-opened") || true,
}

export const toggleMenu = createAsyncThunk("handling/toggleMenu", async (_, { getState }) => {
  const currentState = getState()
  const newValue = !currentState.handling.menuOpened
  localStorage.setItem("menu-opened", newValue)
  return newValue
})

export const setActivePopup = createAsyncThunk("handling/setActivePopup", async (popupName, { dispatch }) => {
  return popupName
})

export const handlingSlice = createSlice({
  name: "handling",
  initialState,
  reducers: {
    setWindowSize: (state, action) => {
      state.size = {
        ...action.payload,
        mobile: isMobile(action.payload),
        landscape: isLandscape(action.payload),
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(toggleMenu.fulfilled, (state, action) => {
      state.menuOpened = action.payload
    })
    builder.addCase(setActivePopup.fulfilled, (state, action) => {
      state.activePopup = action.payload
    })
  },
})

export const { setWindowSize } = handlingSlice.actions

export const selectSize = (state) => state.handling.size

export default handlingSlice.reducer
